const KEY_EDITOR = "progsity:playground:split:editor";
const KEY_OUTPUT = "progsity:playground:split:output";

/** Fraction of main row (editor | output+stdin): ~0.32–0.78 */
export function loadEditorSplitFraction(): number {
  if (typeof window === "undefined") return 0.55;
  try {
    const v = localStorage.getItem(KEY_EDITOR);
    if (v == null) return 0.55;
    const n = Number.parseFloat(v);
    if (Number.isFinite(n) && n >= 0.32 && n <= 0.78) return n;
  } catch {
    /* ignore */
  }
  return 0.55;
}

export function saveEditorSplitFraction(value: number): void {
  try {
    localStorage.setItem(KEY_EDITOR, String(value));
  } catch {
    /* ignore */
  }
}

/** Fraction of right column height (output | stdin): ~0.22–0.88 */
export function loadOutputSplitFraction(): number {
  if (typeof window === "undefined") return 0.58;
  try {
    const v = localStorage.getItem(KEY_OUTPUT);
    if (v == null) return 0.58;
    const n = Number.parseFloat(v);
    if (Number.isFinite(n) && n >= 0.22 && n <= 0.88) return n;
  } catch {
    /* ignore */
  }
  return 0.58;
}

export function saveOutputSplitFraction(value: number): void {
  try {
    localStorage.setItem(KEY_OUTPUT, String(value));
  } catch {
    /* ignore */
  }
}
